// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".addForm[data-v-12f7416a]{width:100%}.addForm .el-form-item[data-v-12f7416a]{width:60%;margin:0 auto;margin-bottom:16px}", ""]);
// Exports
module.exports = exports;
